import { render, staticRenderFns } from "./QueueTicket.vue?vue&type=template&id=07f78c32&scoped=true&"
import script from "./QueueTicket.vue?vue&type=script&lang=js&"
export * from "./QueueTicket.vue?vue&type=script&lang=js&"
import style0 from "./QueueTicket.vue?vue&type=style&index=0&id=07f78c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f78c32",
  null
  
)

export default component.exports